// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rAlxR","text":"styles_text__PcU8L","flag":"styles_flag__9DD7v"};